import {useState} from "react";
import { ReactComponent as MyConnections } from "../../assests/icons/connections_home_my_connections.svg";
import { ReactComponent as SentRequests } from "../../assests/icons/connections_home_sent_requests.svg";
import { ReactComponent as ReceivedRequests } from "../../assests/icons/connections_home_received_requests.svg";
import { CardBox, CardText, CardTextAndCount } from "./ConnectionHomeCard.styles";
import { useNavigate } from "react-router-dom";
import { NAVIGATION_PATHS, homeToken } from "../../utils/constant";
import { useTranslation } from "react-i18next";

const ConnectionsHomeCardIcon = (type, isHover) => {
  switch (type) {
    case "ReceivedRequests":
      return (
        <ReceivedRequests style={{ fill: isHover ? "#CF2030" : "#64666A" }} />
      );
      break;
    case "SentRequests":
      return <SentRequests style={{ fill: isHover ? "#CF2030" : "#64666A" }} />;
      break;
    default:
      return (
        <MyConnections style={{ fill: isHover ? "#CF2030" : "#64666A" }} />
      );
  }
};

const ConnectionHomeCard = ({ type, count }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [isHover, setIsHover] = useState(false);

  return (
    <CardBox
      onClick={() => navigate(NAVIGATION_PATHS[type])}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      {ConnectionsHomeCardIcon(type, isHover)}
      <CardTextAndCount >
        <CardText ishover={isHover.toString()}>{`${t(homeToken[type])}`}</CardText>
        <CardText ishover={isHover.toString()}>&nbsp;{`(${count})`}</CardText>
      </CardTextAndCount>
    </CardBox>
  );
};

export default ConnectionHomeCard;
